const LOGGED_IN = "LOGGED_IN";
const UPDATE_USER_INFO = "UPDATE_USER_INFO";
const LOADING = "LOADING";
const PARENT2_TOKEN = "PARENT2_TOKEN";
const SCHOOL_CODE = "SCHOOL_CODE";
const LOGGED_OUT = "LOGGED_OUT";
const SET_TOKEN = "SET_TOKEN";
const SET_NEW_TERM = "SET_NEW_TERM";
const MOBILE_LOGIN = "MOBILE_LOGIN";
const SET_AS_NATIVE = "SET_AS_NATIVE";
const UPDATE_UNREAD_COUNT = "UPDATE_UNREAD_COUNT";
const REFRESH_ADMIN_INFO = "REFRESH_ADMIN_INFO";
const SET_REFRESH_TOKEN = "SET_REFRESH_TOKEN";

export {
  LOGGED_IN,
  UPDATE_USER_INFO,
  LOADING,
  PARENT2_TOKEN,
  SCHOOL_CODE,
  LOGGED_OUT,
  SET_TOKEN,
  SET_NEW_TERM,
  MOBILE_LOGIN,
  SET_AS_NATIVE,
  UPDATE_UNREAD_COUNT,
  REFRESH_ADMIN_INFO,
  SET_REFRESH_TOKEN
};
